
export default {
  name: 'ProductPriceItem',

  props: {
    originalPrice: {
      type: String,
      required: true,
      default: '',
    },
    discountPrice: {
      type: String,
      required: false,
      default: '',
    },
    prefix: {
      type: String,
      required: false,
      default: '',
    },
    postfix: {
      type: String,
      required: false,
      default: '',
    },
    subText: {
      type: String,
      required: false,
      default: '',
    },
    tooltipContent: {
      type: String,
      required: false,
      default: '',
    },
    mode: {
      type: String,
      required: false,
      default: 'default',
    },
    negative: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSorted: {
      type: Boolean,
      required: false,
      default: false
    },
    isTextBlack: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    isDefaultMode() {
      return this.mode === 'default';
    },
  },
};
